import axios, { AxiosResponse, AxiosError } from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const setupAxiosInterceptors = () => {
  const onResponseSuccess = (response: AxiosResponse) => response;
  const onResponseError = (err: AxiosError) => {
    return Promise.reject(err);
  };

  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export { setupAxiosInterceptors };
